export const RESET = 'COMPANY_PRODUCT_UPDATE_RESET'
export const SET_ERROR = 'COMPANY_PRODUCT_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'COMPANY_PRODUCT_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'COMPANY_PRODUCT_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'COMPANY_PRODUCT_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'COMPANY_PRODUCT_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'COMPANY_PRODUCT_UPDATE_UPDATE_RETRIEVED'
export const SET_FILES = 'COMPANY_PRODUCT_UPDATE_FILES'
